module.exports = __webpack_public_path__ + "static/media/export-icon-white.6f405a1e.svg";